import React from "react";
import { getSupabaseClient } from "../../lib/supabaseClient";

export const AuthContext = React.createContext({
    user: null,
    session: null,
    isAuthReady: false,
    isSupabaseConfigured: false,
    signInWithEmail: async () => {},
    signOut: async () => {},
});

function AuthProvider({ children }) {
    const supabase = getSupabaseClient();
    const [session, setSession] = React.useState(null);
    const [isAuthReady, setIsAuthReady] = React.useState(!supabase);

    React.useEffect(() => {
        if (!supabase) {
            setIsAuthReady(true);
            return;
        }

        supabase.auth.getSession().then(({ data }) => {
            setSession(data.session);
            setIsAuthReady(true);
        });

        const { data } = supabase.auth.onAuthStateChange((_event, newSession) => {
            setSession(newSession);
            setIsAuthReady(true);
        });

        return () => {
            data?.subscription?.unsubscribe();
        };
    }, [supabase]);

    const signInWithEmail = async (email) => {
        if (!supabase) {
            throw new Error("Supabase is not configured.");
        }
        return supabase.auth.signInWithOtp({
            email,
            options: {
                emailRedirectTo: window.location.origin,
            },
        });
    };

    const signOut = async () => {
        if (!supabase) return;
        await supabase.auth.signOut();
        setSession(null);
    };

    return (
        <AuthContext.Provider
            value={{
                user: session?.user ?? null,
                session,
                isAuthReady,
                isSupabaseConfigured: !!supabase,
                signInWithEmail,
                signOut,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;
